import { type AnyAction, combineReducers } from 'redux';
import Immutable from 'immutable';

import { hideModal, showModal } from 'js/src/data/modals/modals-actions';
import type { MODAL_IDS } from 'js/src/data/modals/modals-types';

/**
 * A stack of strings is used to keep track of visible modals. The modal at the top
 * of the stack, if any, is the modal currently being shown
 */
export function visible_stack(state = Immutable.Stack<MODAL_IDS>(), action: AnyAction) {
    if (showModal.match(action)) {
        return state.push(action.payload.modal_id);
    }
    if (hideModal.match(action)) {
        return state.pop();
    }
    return state;
}

/**
 * A stack containing any data type used to keep track of any custom data. This stack
 * is kept in sync with the visible_stack defined above.
 */
export function visible_stack_context(state = Immutable.Stack<unknown>(), action: AnyAction) {
    if (showModal.match(action)) {
        return state.push(action.payload.modal_context);
    }
    if (hideModal.match(action)) {
        return state.pop();
    }
    return state;
}

export const modals = combineReducers({
    visible_stack,
    visible_stack_context,
});

export type ModalsState = ReturnType<typeof modals>;
